import { Modal, Button } from "antd";
import { ExclamationCircleOutlined, CalendarOutlined, InfoCircleOutlined } from "@ant-design/icons";

const PostCloseSalesModal = ({ open, storeClosedDate, newBusinessDate, closedTime, tillId, cashierName, onContinue, onCancel }) => {
  return (
    <Modal open={open} centered closable={true} onCancel={onCancel} footer={null} width={480} styles={{ body: { padding: "24px" } }}>
      {/* Header with Warning Icon and Title */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            backgroundColor: "#FFF7E6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "12px",
          }}
        >
          <ExclamationCircleOutlined style={{ fontSize: "24px", color: "#FAAD14" }} />
        </div>
        <span style={{ fontSize: "18px", fontWeight: "600", color: "#1F2937" }}>Post Close Sales Confirmation</span>
      </div>

      {/* Description Text */}
      <p style={{ color: "#6B7280", fontSize: "14px", marginBottom: "24px", lineHeight: "1.5" }}>
        Store was closed at {closedTime || "8:00 PM"}. As per Day End Preferences, new sales will be recorded for the next business date.
      </p>

      {/* Date Boxes Container */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        {/* Store Closed Date Box */}
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "8px" }}>Store Closed Date</div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <CalendarOutlined style={{ marginRight: "8px", color: "#6B7280" }} />
            <span style={{ fontWeight: "500", color: "#1F2937" }}>{storeClosedDate}</span>
          </div>
        </div>

        {/* Arrow */}
        <div style={{ marginTop: "20px" }}>
          <span style={{ fontSize: "20px", color: "#9CA3AF" }}>→</span>
        </div>

        {/* New Business Date Box */}
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "8px" }}>New Business Date</div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 16px",
              border: "1px solid #1E3A5F",
              borderRadius: "8px",
              backgroundColor: "#1E3A5F",
              color: "#FFFFFF",
            }}
          >
            <CalendarOutlined style={{ marginRight: "8px", color: "#FFFFFF" }} />
            <span style={{ fontWeight: "500" }}>{newBusinessDate}</span>
          </div>
        </div>
      </div>

      {/* Till ID and Cashier Info */}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          justifyContent: "flex-start",
          gap: "70px",
          marginBottom: "16px",
          paddingLeft: "24px",
        }}
      >
        <div>
          <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Till ID</div>
          <div style={{ fontWeight: "600", color: "#1F2937", fontSize: "14px" }}>{tillId}</div>
        </div>
        <div>
          <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Cashier</div>
          <div style={{ fontWeight: "600", color: "#1F2937", fontSize: "14px" }}>{cashierName}</div>
        </div>
      </div> */}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          gap: "16px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            backgroundColor: "#F9FAFB",
            borderRadius: "8px",
            padding: "6px 16px",
            minWidth: "205px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#6B7280",
              marginBottom: "4px",
            }}
          >
            Till ID
          </div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#1F2937",
            }}
          >
            {tillId}
          </div>
        </div>

        <div
          style={{
            backgroundColor: "#F9FAFB",
            borderRadius: "8px",
            padding: "6px 16px",
            minWidth: "205px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#6B7280",
              marginBottom: "4px",
            }}
          >
            Cashier
          </div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#1F2937",
            }}
          >
            {cashierName}
          </div>
        </div>
      </div>

      {/* Info Box */}
      <div
        style={{
          backgroundColor: "#EFF6FF",
          borderRadius: "8px",
          padding: "12px 16px",
          display: "flex",
          alignItems: "flex-start",
          marginBottom: "16px",
        }}
      >
        <InfoCircleOutlined style={{ color: "#6B7280", marginRight: "10px", marginTop: "2px" }} />
        <span style={{ color: "#374151", fontSize: "13px", lineHeight: "1.5" }}>
          All transactions made in this session will be recorded under the business date <strong>{newBusinessDate}</strong>. A new shift will be created for this date.
        </span>
      </div>

      {/* Footer Text */}
      <p style={{ fontSize: "13px", color: "#6B7280", textAlign: "center", marginBottom: "20px" }}>
        Click <strong>Continue</strong> to proceed with the next business date or <strong>Cancel</strong> to return to login.
      </p>

      {/* Action Buttons */}
      <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
        <Button
          onClick={onCancel}
          style={{
            height: "40px",
            padding: "0 24px",
            borderRadius: "6px",
            fontWeight: "500",
          }}
        >
          Cancel & Logout
        </Button>
        <Button
          type="primary"
          onClick={onContinue}
          style={{
            height: "40px",
            padding: "0 24px",
            borderRadius: "6px",
            fontWeight: "500",
            backgroundColor: "#1E3A5F",
            borderColor: "#1E3A5F",
          }}
        >
          Continue with Next Business Date
        </Button>
      </div>
    </Modal>
  );
};

export default PostCloseSalesModal;
